/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Location_ErrorInputs */

const vi_camera_location_error = /** @type {(inputs: Camera_Location_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không đổi được nơi đặt camera`)
};

/**

* @param {Camera_Location_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_location_error = /** @type {((inputs?: Camera_Location_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Location_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_location_error(inputs)
});